import { Helmet, HelmetProvider } from "react-helmet-async";

const SEO = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>
          Find a drone pilot in the US - All Drone Services - SkyyTask
        </title>
        <meta
          name="description"
          content="Meet SkyyTask, the first Drone App that solves problems for all industries. Save time, Post jobs, Find Pilots, Be Connected. All Flight, One Site"
        />
        <meta property="og:title" content="SkyyTask" />
        <meta property="og:url" content="https://www.skytask.com" />
        <meta
          property="og:description"
          content="Meet SkyyTask, the first Drone App that solves problems for all industries. Save time, Post jobs, Find Pilots, Be Connected. All Flight, One Site"
        />
        <meta
          name="twitter:description"
          content="Meet SkyyTask, the first Drone App that solves problems for all industries. Save time, Post jobs, Find Pilots, Be Connected. All Flight, One Site"
        />
        <meta property="og:image" content="/favicon.ico" />
      </Helmet>
    </HelmetProvider>
  );
};

export default SEO;
